import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  return (
    <button data-testid="theme-toggle" onClick={toggle} title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
      className="w-10 h-10 rounded-xl bg-slate-900 border border-slate-800 hover:bg-slate-800 flex items-center justify-center transition-colors">
      {theme === "dark" ? <Sun className="w-5 h-5 text-amber-300" /> : <Moon className="w-5 h-5 text-slate-500" />}
    </button>
  );
}
